import { HttpService } from "../../modules/shared/services/http.service";
import { 
  PageManagement, 
  PageManagementCreateDto, 
  PageManagementUpdateDto,
  PageManagementResponse,
  QueryPageManagementDto,
  PageStatusObject,
  PageLayoutObject,
  pageStatusEnum,
  pageTypeEnum
} from "../../modules/shared/model/page-management.interfaces";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Helper functions to convert between frontend and API formats
const convertToApiFormat = (data: PageManagementCreateDto): any => {
  const apiData = {
    status: data.status || { id: pageStatusEnum.Draft, name: "Draft" },
    type: data.type || { id: pageTypeEnum["Default Layout"], name: "Default Layout" },
    enableRoleBased: data.enableRoleBased || false,
    isText: data.isText !== undefined ? data.isText : true,
    metaKeywords: data.metaKeywords || [],
    metaDescription: data.metaDescription || "",
    content: data.content || "",
    url: data.url || "",
    title: data.title || ""
  };
  
  console.log("convertToApiFormat - Original data:", data);
  console.log("convertToApiFormat - API data:", apiData);
  console.log("convertToApiFormat - isText value:", apiData.isText, "type:", typeof apiData.isText);
  
  return apiData;
};

const convertFromApiFormat = (apiData: any): PageManagement => {
  return {
    id: apiData.id,
    status: apiData.status,
    type: apiData.type,
    enableRoleBased: apiData.enableRoleBased,
    isText: apiData.isText,
    metaKeywords: apiData.metaKeywords,
    metaDescription: apiData.metaDescription,
    content: apiData.content,
    url: apiData.url,
    title: apiData.title,
    createdAt: apiData.createdAt, // Keep as string for serialization
    updatedAt: apiData.updatedAt   // Keep as string for serialization
  };
};

// Get all page managements with pagination
export const getPageManagements = async (query?: QueryPageManagementDto): Promise<PageManagementResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) {
      if (k === "filters" || k === "sort") {
        qs.append(k, JSON.stringify(v));
      } else {
        qs.append(k, String(v));
      }
    }
  });
  const response = await HttpService.get(`api/v1/page-managements${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  
  // Convert API response to frontend format
  return {
    ...response,
    data: response.data?.map(convertFromApiFormat) || []
  };
};

// Get page management by ID
export const getPageManagementById = async (id: string): Promise<PageManagement> => {
  const response = await HttpService.get(`api/v1/page-managements/${id}`, true, { "x-custom-lang": "en" });
  return convertFromApiFormat(response);
};


// Create new page management
export const createPageManagement = async (data: PageManagementCreateDto): Promise<PageManagement> => {
  console.log("createPageManagement - Input data:", data);
  const apiData = convertToApiFormat(data);
  console.log("createPageManagement - Sending to API:", apiData);
  const response = await HttpService.post("api/v1/page-managements", apiData, headers, true);
  console.log("createPageManagement - API response:", response);
  return convertFromApiFormat(response);
};

// Update page management
export const updatePageManagement = async (id: string, data: PageManagementUpdateDto): Promise<PageManagement> => {
  console.log("updatePageManagement - Input data:", data);
  const apiData = convertToApiFormat(data as PageManagementCreateDto);
  console.log("updatePageManagement - Sending to API:", apiData);
  const response = await HttpService.patch(`api/v1/page-managements/${id}`, apiData, headers, true);
  console.log("updatePageManagement - API response:", response);
  return convertFromApiFormat(response);
};

// Delete page management
export const deletePageManagement = async (id: string): Promise<void> => {
  await HttpService.deleteRecord(`api/v1/page-managements/${id}`, { "x-custom-lang": "en" }, true);
};



